module.exports = __webpack_public_path__ + "static/media/EL-storie-illustrate-5.40148440.jpg";